import type { ReactElement } from "react";
import { Size, IconAlignment } from "../UiEnums";
import type { Item } from "../items";
import "./RadioButton.scss";
import "@/shared/style/design_system/Fonts.scss";
import classNames from "classnames";

interface Properties {
  alignIcon?: IconAlignment;
  onChange: (item: Item, selected: boolean) => void;
  size?: Size;
  selected?: boolean;
  disabled?: boolean;
  item: Item;
}

export default function RadioButton({
  alignIcon = IconAlignment.LEFT,
  onChange,
  size = Size.LARGE,
  selected = false,
  disabled = false,
  item,
}: Properties): ReactElement {
  function limitSize(): Size {
    // Cap generic checkbox size to what's defined in design system:
    const capSize = (): Size => {
      switch (size) {
        case Size.XXXLARGE:
        case Size.XXLARGE:
        case Size.XLARGE:
          return Size.LARGE;
        case Size.XSMALL:
          return Size.SMALL;
        default:
          return size;
      }
    };
    const cappedSize = capSize();
    if (cappedSize !== size) {
      console.warn(
        `RadioButton isn't available for size ${size}, using ${cappedSize} instead`,
      );
    }
    return cappedSize;
  }

  function radioButtonClasses(): string {
    return classNames(
      "radio-button",
      "body",
      size === Size.LARGE ? "medium" : "small",
      sizeClass(),
      disabled && "disabled",
      selected && "selected",
    );
  }

  function sizeClass(): string {
    return Size[limitSize()].toLocaleLowerCase();
  }

  function radioClasses(): string {
    return classNames("radio", selected && "selected");
  }

  const iconDiv = (
    <div className={radioClasses()}>
      <div className="disk" />
    </div>
  );

  return (
    <div
      className={radioButtonClasses()}
      onClick={() => {
        onChange(item, !selected);
      }}
    >
      {alignIcon === IconAlignment.LEFT && iconDiv}
      <div>{item.label}</div>
      {alignIcon === IconAlignment.RIGHT && iconDiv}
    </div>
  );
}
